<template>
  <div class="error-modal">
    <div class="modal fade" id="errorModal" tabindex="false" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="errorModal">
              There was an error processing your request
            </h4>
          </div>
          <div class="modal-body">
            <div class="alert alert-danger">
              <p>{{{ errorMessage }}}</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Dismiss
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  name: 'ErrorModal',
  props: {
    errorMessage: {
      type: String
    }
  },
  ready () {
    let modals = $('.modal')
    for (let i = 0; i < modals.length; i++) {
      let modal = modals[i]
      $(modal).on('hidden.bs.modal', function (e) {
        let hasModals = $('.modal')
        if (hasModals.length > 1) {
          $('body').addClass('modal-open')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ErrorModal.vue?09f82c28